import not_found from "../img/not_found.svg";

function NotFound() {
  return (
    <>
      <div className=" d-flex flex-column justify-content-between align-items-center mt-4 gap-4">
        <img
          className=""
          src={not_found}
          style={{
            objectFit: "contain",
            height: "100%",
            width: "40vw",
          }}
        />
        <p className="h1 text-center">Not Found</p>
      </div>
    </>
  );
}

export default NotFound;
